module.exports = __webpack_public_path__ + "imgs/proteus.30229df93e1f752e82531d37ddf5cebf.jpg";